/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a harmonious colour palette from any starting colour. Choose a harmony rule and get matching colours with hex codes you can copy with a click.`)
};

const es_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observa cómo crece un depósito único con interés compuesto. Ingresa el monto, la tasa, los años y la frecuencia de capitalización.`)
};

const de_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie, wie eine einmalige Einzahlung durch Zinseszins wächst. Geben Sie den Betrag, den Zinssatz, die Jahre und die Häufigkeit der Zinseszinsberechnung ein.`)
};

const nl_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk hoe een eenmalige inleg groeit met samengestelde rente. Voer het bedrag, rentepercentage, jaren en renteverrekening in.`)
};

const fr_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyez comment un dépôt unique croît avec intérêt composé. Entrez le montant, le taux, les années et la fréquence de composition des intérêts.`)
};

const it_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi come un deposito una tantum cresce con l'interesse composto. Inserisci l'importo, il tasso, gli anni e la frequenza di capitalizzazione.`)
};

const pt_br2_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja como um depósito único cresce com juros compostos. Digite o valor, a taxa, os anos e com que frequência os juros são capitalizados.`)
};

const pt_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja como um depósito único cresce com juros compostos. Introduza o montante, taxa, anos e com que frequência o juro é capitalizado.`)
};

const ja_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一度の預金がどのように複利で成長するかを確認しましょう。金額、利率、年数、複利計算期間を入力してください。`)
};

const zh_cp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看一次性存款如何通过复利增长。输入金额、利率、年数以及利息复利的频率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_intro", locale)
	if (locale === "en") return en_cp_intro(inputs)
	if (locale === "es") return es_cp_intro(inputs)
	if (locale === "de") return de_cp_intro(inputs)
	if (locale === "nl") return nl_cp_intro(inputs)
	if (locale === "fr") return fr_cp_intro(inputs)
	if (locale === "it") return it_cp_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cp_intro(inputs)
	if (locale === "pt") return pt_cp_intro(inputs)
	if (locale === "ja") return ja_cp_intro(inputs)
	return zh_cp_intro(inputs)
};